<template>
    <div class="">
        <div class="success">
            <img src="../assets/success.png" alt="">
            <h1>支付成功</h1>
        </div>

    </div>
</template>

<script>




export default {
    name: "Notice",
    props: {

    },
    data() {
        return {
            timerId: null, // 用于保存定时器ID
        }
    },
    created() {
        this.timerId = setTimeout(() => {
            this.$router.push('/seat');
        }, 2000);
    },
    beforeDestroy() {
        // 在组件销毁前清除定时器
        if (this.timerId !== null) {
            clearTimeout(this.timerId);
            this.timerId = null; // 可选：将定时器ID重置为null，避免后续误操作
        }
    },
    methods: {




    }
}
</script>


<style scoped lang="scss">
.success {
    text-align: center;
    margin-top: 50px;

    img {
        // width: 200px;
        height: 200px;
    }

    h1 {
        padding: 0;
        margin: 0;
        letter-spacing: 5px;
    }
}
</style>
